module.exports = __webpack_public_path__ + "img/5.c9d5be16.png";